export default __webpack_public_path__ + "static/media/explosion-puntos.4ea6c138.png";